import {Box, CenterBox} from '@buncha/components/core/view';
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {StyleProp, TextStyle} from 'react-native';

import {B2BUserScreens} from '@buncha/B2B/navigation/types';
import {CustomImage} from '@buncha/components/core/Image';
// import {CustomText} from '@buncha/components/core/text';
// import DefaultBunchaLogo from '@buncha/components/core/icon/DefaultBunchaLogo';
import If from '@buncha/components/conditional/If';
import {MainScreens} from '@buncha/navigation/types';
import {Skeleton} from 'native-base';
import Star from '@buncha/components/core/icon/Star';
import {Touchable} from '@buncha/components/core/touchable';
import {navigation} from '@buncha/config/navigation';
import {scaleFonts} from '@buncha/appStyles/style/font';
import {styles} from './styles';
import {useColorThemeType} from '@buncha/appStyles/hooks/theme';

interface ShopperProfileImageProps {
  imageWidth: number;
  imageHeight: number;
  buttonWidth?: number;
  textStyle?: StyleProp<TextStyle>;
  assigneeId: string;
  isShopper: boolean;
  imageUrl?: string;
  phoneNumber: string;
  showStarBadge?: boolean;
}

const ShopperProfileImage: React.FC<ShopperProfileImageProps> = ({
  imageWidth,
  imageHeight,
  // buttonWidth,
  // textStyle,
  assigneeId,
  isShopper,
  imageUrl,
  phoneNumber,
  showStarBadge,
}) => {
  // const muliFont = useFontTheme();
  const theme = useColorThemeType();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const verifyImage = () => {
      setLoading(true);
      setLoading(false);
    };

    verifyImage();
  }, [imageUrl]);

  const getProfileImage = useMemo(() => {
    if (imageUrl?.length)
      return (
        <CustomImage
          style={[
            styles.image,
            {
              height: imageHeight,
              width: imageWidth,
            },
          ]}
          source={imageUrl}
        />
      );
    return (
      <Box
        style={[
          styles.defaultBunchaBox,
          {
            backgroundColor: theme?.background?.yellow?.[400],
            height: imageHeight,
            width: imageWidth,
          },
        ]}>
        {/* <DefaultBunchaLogo
          height={130}
          width={185}
          viewBox="-55 -50 295 250"
          fill={theme?.background?.yellow?.[400]}
        /> */}
        <CustomImage
          resizeMode="cover"
          style={[
            styles.defaultImage,
            {
              height: imageHeight,
              width: imageWidth,
            },
          ]}
          source={
            'https://gobuncha-fulfillment.gobuncha.com/profile-images/default-profile-image.png'
          }
        />
      </Box>
    );
  }, [imageHeight, imageUrl, imageWidth, theme?.background?.yellow]);

  const navigateToShopperInfo = useCallback(() => {
    navigation.navigate(MainScreens.B2B, {
      screen: B2BUserScreens.ShopperInfo,
      params: {
        assigneeId,
        isShopper,
        phoneNumber,
      },
    });
  }, [assigneeId, isShopper, phoneNumber]);

  return (
    <CenterBox>
      <If condition={loading}>
        <Skeleton
          height={imageHeight}
          width={imageWidth}
          style={styles.defaultBunchaBox}
        />
      </If>
      <If condition={!loading}>
        <Box style={styles.imageBox}>
          {getProfileImage}

          {/* ⭐ STAR BADGE */}
          <If condition={showStarBadge}>
            <Box style={styles.starBadge}>
              <Star
                width={scaleFonts(24)}
                height={scaleFonts(24)}
                viewBox="0 0 24 24"
                fill={theme?.background.yellow[100]}
              />
            </Box>
          </If>
        </Box>
      </If>
      <Touchable
        onPress={navigateToShopperInfo}
        style={[
          styles.touchable,
          {backgroundColor: theme?.background.white[100]},
        ]}>
        {/* <Box
          style={[
            styles.button,
            {
              width: buttonWidth ?? imageWidth - 20,
              backgroundColor: theme?.background.white[100],
            },
          ]}>
          <CustomText
            style={[
              styles.text,
              {
                fontFamily: muliFont[700].normal,
                color: theme?.text.blue[300],
              },
              textStyle,
            ]}>
            View Details
          </CustomText>
        </Box> */}
      </Touchable>
    </CenterBox>
  );
};

export default React.memo(ShopperProfileImage);
